import { useTranslations } from 'next-intl';
import { CatButton } from '@blocks-react/components/Button';
import { CatHeading } from '@blocks-react/components/Heading';
import { RequestServiceModal, useBreakpoint } from '@cat-ecom/pcc-components';
import { MODAL_BREAKPOINTS } from '../constant';
import { PAGE_BREAKPOINTS } from 'constants/common';

const RequestEquipmentServiceLeavePage = ({
  isLeavePageModelActive,
  setIsLeavePageModelActive,
  modalClose
}) => {
  const t = useTranslations();
  const isMd = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const fullWidth = isMd ? MODAL_BREAKPOINTS.md : MODAL_BREAKPOINTS.sm;

  const onLeaveModalClose = () => {
    setIsLeavePageModelActive(false);
  };
  const onLeaveModalConfirm = () => {
    onLeaveModalClose();
    modalClose();
  };
  return (
    <RequestServiceModal
      isActive={isLeavePageModelActive}
      dismissible={false}
      disableBackdropClick={true}
      disableEscClick={true}
      width={fullWidth}
    >
      <CatHeading slot="header" variant="title-sm">
        {t('LEAVE_PAGE')}
      </CatHeading>
      <CatHeading variant="body-sm">{t('LEAVE_PAGE_MSG')}</CatHeading>
      <div slot="footer" className="d-flex pt-4">
        <CatButton
          variant="danger"
          className="me-1"
          onClick={onLeaveModalConfirm}
        >
          {t('LEAVE')}
        </CatButton>
        <CatButton className="ms-1" onClick={onLeaveModalClose}>
          {t('UC_BACK')}
        </CatButton>
      </div>
    </RequestServiceModal>
  );
};

export default RequestEquipmentServiceLeavePage;
